export default __webpack_public_path__ + "static/media/digital-risk-assement.ba371370.png";